// extracted by mini-css-extract-plugin
module.exports = {"loader":"PageOverlayLoader_loader__33agz","loaderOuter":"PageOverlayLoader_loaderOuter__4WpZR"};